import React, { useEffect, useState, useRef } from "react";
import PaymentDataService from "../../services/payment.service";
import SupplierDataService from "../../services/supplier.service";
import MemberDataService from "../../services/admin.service";
import { Link, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";

import { selectMessage } from "../../features/auth/authSlice";

import { useFormik } from "formik";
import * as Yup from "yup";

import BackButton from "../BackButton.js";

const AddSupplier = () => {
    const form = useRef();
    const checkBtn = useRef();
    const amount = useRef();
    const [successful, setSuccessful] = useState(false);

    const [suppliers, setSuppliers] = useState([]);
    const [members, setMembers] = useState([]);

    const retrieveSuppliers = () => {
        SupplierDataService.getAll()
            .then((response) => {
                setSuppliers(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const retrieveMembers = () => {
        MemberDataService.getAll()
            .then((response) => {
                setMembers(response.data);
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const message = useSelector(selectMessage);

    let navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        type: Yup.string().required("Type is required"),
        // .min(1, "Name must be at least 1 characters")
        // .max(50, "Name must not exceed 50 characters"),
        recipientId: Yup.number().required("Supplier is required"),
        amount: Yup.number().required("Amount is required"),
        date: Yup.date().required("Date is required"),
        notes: Yup.string(),
    });

    const formik = useFormik({
        initialValues: {
            type: "",
            recipientId: undefined,
            amount: 0,
            date: new Date().toISOString().substring(0, 10),
            notes: "",
        },
        validationSchema,
        // validateOnChange: false,
        // validateOnBlur: false,
        onSubmit: (payment) => {
            PaymentDataService.create(
                payment.type,
                payment.recipientId,
                payment.amount,
                payment.date,
                payment.notes
            )
                .then(() => {
                    setSuccessful(true);
                    navigate("/payments");
                })
                .catch(() => {
                    setSuccessful(false);
                });
        },
        onReset: () => {
            navigate("/payments");
        },
    });

    useEffect(() => {
        retrieveSuppliers();
        retrieveMembers();
    }, []);

    return (
        <div className="col-md-12 module-form">
            <BackButton returnPath="/payments"></BackButton>

            <h4 className="page-title">Add payment</h4>

            <form onSubmit={formik.handleSubmit} ref={form}>
                {!successful && (
                    <div>
                        <div className="form-group">
                            <label htmlFor="type"> Type </label>
                            <select
                                name="type"
                                className={
                                    "form-select" +
                                    (formik.errors.type && formik.touched.type
                                        ? " is-invalid"
                                        : "")
                                }
                                onChange={formik.handleChange}
                                value={formik.values.type}
                            >
                                <option value={undefined}></option>
                                <option value="Supplier">Supplier</option>
                                <option value="User">User</option>
                            </select>
                            <div className="invalid-feedback">
                                {formik.errors.type && formik.touched.type
                                    ? formik.errors.type
                                    : null}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="recipientId"> Recipient </label>
                            <div className="input-group">
                                <Link
                                    to={"/suppliers/add"}
                                    state={{ returnTo: "/payments/add" }}
                                    className="btn btn-outline-success"
                                >
                                    <i class="bi bi-plus-square"></i>
                                </Link>
                                <select
                                    name="recipientId"
                                    className={
                                        "form-select" +
                                        (formik.errors.recipientId &&
                                        formik.touched.recipientId
                                            ? " is-invalid"
                                            : "")
                                    }
                                    onChange={formik.handleChange}
                                    value={formik.values.recipientId}
                                    style={{ borderRadius: "0 6px 6px 0" }}
                                >
                                    <option key="#0" value={undefined}></option>

                                    {formik.values.type === "Supplier"
                                        ? suppliers.map((cc, i) => (
                                              <option
                                                  key={`#${i}`}
                                                  value={cc.id}
                                              >
                                                  {cc.name}
                                              </option>
                                          ))
                                        : formik.values.type === "User"
                                        ? members.map((cc, i) => (
                                              <option
                                                  key={`#${i}`}
                                                  value={cc.id}
                                              >
                                                  {cc.username}
                                              </option>
                                          ))
                                        : null}
                                </select>
                                <div className="invalid-feedback">
                                    {formik.errors.recipientId &&
                                    formik.touched.recipientId
                                        ? formik.errors.recipientId
                                        : null}
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="amount"> Amount </label>
                            <input
                                name="amount"
                                ref={amount}
                                type="number"
                                className={
                                    "form-control" +
                                    (formik.errors.amount &&
                                    formik.touched.amount
                                        ? " is-invalid"
                                        : "")
                                }
                                onChange={formik.handleChange}
                                onFocus={() => {
                                    amount.current.select();
                                }}
                                value={formik.values.amount}
                            />
                            <div className="invalid-feedback">
                                {formik.errors.amount && formik.touched.amount
                                    ? formik.errors.amount
                                    : null}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="date"> Date </label>
                            <input
                                name="date"
                                type="date"
                                className={
                                    "form-control" +
                                    (formik.errors.date && formik.touched.date
                                        ? " is-invalid"
                                        : "")
                                }
                                onChange={formik.handleChange}
                                value={formik.values.date}
                            />
                            <div className="invalid-feedback">
                                {formik.errors.date && formik.touched.date
                                    ? formik.errors.date
                                    : null}
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="notes"> Notes </label>
                            <textarea
                                name="notes"
                                className={
                                    "form-control" +
                                    (formik.errors.notes && formik.touched.notes
                                        ? " is-invalid"
                                        : "")
                                }
                                onChange={formik.handleChange}
                                value={formik.values.notes}
                            />
                            <div className="invalid-feedback">
                                {formik.errors.notes && formik.touched.notes
                                    ? formik.errors.notes
                                    : null}
                            </div>
                        </div>

                        <hr></hr>

                        <div className="form-group">
                            <button type="submit" className="btn btn-success">
                                Save
                            </button>{" "}
                            <button
                                type="button"
                                className="btn btn-danger float-right"
                                onClick={formik.handleReset}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {/* {message && (
                    <div className="form-group">
                        <div
                            className={
                                successful
                                    ? "alert alert-success"
                                    : "alert alert-danger"
                            }
                            role="alert"
                        >
                            {message}
                        </div>
                    </div>
                )}
                <button style={{ display: "none" }} ref={checkBtn}></button> */}
            </form>
        </div>
    );
};

export default AddSupplier;
